export const environment = {
 production: false,
  apiBaseUrl:'https://aiaapi.in/api/',
  carrierApiBaseUrl: 'https://api.carriersoftware.com/api'
 
};